import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommissionUpdatePackage} from "../../../../shared/interface/commission-update-package";
import {CommissionUpdatePackageService} from "../../../../shared/services/commission-update-package.service";
import {Observable, ReplaySubject} from "rxjs";
import {AuthService} from "../../../../shared/services/auth.service";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {takeUntil} from "rxjs/operators";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";

@Component({
  selector: 'app-commission-update-package-view',
  templateUrl: './commission-update-package-view.component.html',
  styleUrls: ['./commission-update-package-view.component.scss']
})
export class CommissionUpdatePackageViewComponent implements OnInit, OnDestroy {
  @Input() commissionUpdatePackage: Observable<CommissionUpdatePackage>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() commissionUpdatePackageChanged = new EventEmitter<any>();
  userPermissions: ReplaySubject<UserPermissions>;
  commissionUpdatePackageObject: CommissionUpdatePackage;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private commissionUpdatePackageService: CommissionUpdatePackageService,
    private auth: AuthService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.commissionUpdatePackage
      .pipe(takeUntil(this.destroyed$))
      .subscribe((commissionUpdatePackage) => {
        this.commissionUpdatePackageObject = commissionUpdatePackage;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }


  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: { text: 'Czy na pewno chcesz usunąć konfigurację?' },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commissionUpdatePackageService.delete(this.commissionUpdatePackageObject.uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto konfigurację', '', { duration: 2000 });
              this.router.navigate(['/konfigurator']);
            },
            error: (err) => {
              const errorText = err?.error.error?.text || 'Wystąpił nieznany błąd podczas usuwania.';
              this.snack.open(errorText, '', { duration: 4000 });
            }
          });
      }
    });
  }
}
